import { render, staticRenderFns } from "./garbageChart.vue?vue&type=template&id=cda5130c&scoped=true"
import script from "./garbageChart.vue?vue&type=script&lang=js"
export * from "./garbageChart.vue?vue&type=script&lang=js"
import style0 from "./garbageChart.vue?vue&type=style&index=0&id=cda5130c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda5130c",
  null
  
)

export default component.exports